module.exports = __webpack_public_path__ + "img/129.9.10ae4390.png";